/**
 * JAVA异步HTTP请求封装类
 */
import axios from "axios";
import qs from "qs";
import { Toast } from "vant";
import MD5 from "@/libs/MD5";
import env from "../config/env";
import {
  getUserId,
  getToken,
  isWeiXin,
  removeUserId,
  removeToken,
  guid,
} from "../libs/util";

// 遮罩对象
let toaster = null;

export default class HttpRequest {
  // 请求前缀
  // 2026-10-14：PHP 接口下线后 apiUrl / javaApiUrl 已合并为单一 env.apiUrl（/ddy-api）
  static apiUrl = env.apiUrl;

  // 必传参数
  static getRequireParams(param) {
    let randTmp = guid() + (Date.parse(new Date()) / 1000).toString();
    let paramsTmp = {
      ag_source: isWeiXin() ? 5 : 2, //须与APP端获取 1=PC,2=WAP,3=APP安卓,4=IOS安卓,5=微信,
      vsign: MD5.hexMD5("rand=" + randTmp + "&key=" + env.signKeyJavaApi),
      rand: randTmp,
    };
    let userIdTmp = getUserId();
    let tokenTmp = getToken();
    if (userIdTmp) {
      paramsTmp.user_id = userIdTmp;
      paramsTmp.token = tokenTmp;
    }
    return paramsTmp;
  }

  // 配置请求头部
  static _getInsideConfig(method = "get") {
    let config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    if (method != "get") {
      config = {
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        },
      };
    }
    return config;
  }

  /**
   * @param {*} instance
   * @param {*} url
   * @param {*} retParent 是否原样返回
   */
  static _interceptors(instance, url, retOrigin, loading) {
   
    // 请求拦截
    instance.interceptors.request.use(
      (config) => {
        let requireParams = this.getRequireParams();
        if (config.method == "post") {
          config.data = config.data
            ? config.data + "&" + qs.stringify(requireParams)
            : qs.stringify(requireParams);
        } else {
          Object.assign(config.params, requireParams);
        }
        // 防重复提交遮罩
        if (loading) {
          toaster = Toast({
            type: "loading",
            duration: 0,
            overlay: true,
          });
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    // 响应拦截
    instance.interceptors.response.use(
      (response) => {
        const res = response.data;

        if (loading) {
          toaster.clear()
        }

        if (+res.code !== 200) {
          // 未登录
          if (+res.code === 999) {
            removeUserId();
            removeToken();
            // 2026-10-22：目标页由 /initialize 改为 /login —— 叮当云 H5 没有 initialize
            // 路由（那是 mall 轨的页面），/initialize 会落到 * 兜底的 notFound。
            // phpAxios.isSuccess 对 999 也一直是跳 /login。
            window.location.href = window.location.origin + "/login";
          } else {
            Toast({
              // 原为 data.subMsg（data 未定义，提示框恒为空），改正为 res.subMsg
              message: res.subMsg,
              duration: 2000,
            });
          }
          return Promise.reject(res);
        } else {
          if (retOrigin) {
            return res;
          }

          // subCode != 200 提示
          if(+res.subCode !== 200){
            // 997 = 登录态还在但账号已被禁用（后端 UserController 的
            // SUB_CODE_ACCOUNT_DISABLED）。清掉登录态回登录页，并把提示语带过去，
            // 否则整页跳转会把这个 toast 冲掉。
            if (String(res.subCode) === "997") {
              removeUserId();
              removeToken();
              try {
                window.sessionStorage.setItem(
                  "loginBlockedMsg",
                  res.subMsg || "该账号已被禁用，请联系管理员。"
                );
              } catch (e) {
                /* 隐私模式下 sessionStorage 可能不可写，忽略即可 */
              }
              window.location.href = window.location.origin + "/login";
              return Promise.reject(res);
            }
            Toast({
              message: res.subMsg,
              duration: 2000,
            });
            return Promise.reject(res);
          }
          if (res.datas) {
            return res.datas;
          } else if (res.data) {
            return res.data;
          } else {
            return null;
          }
        }
      },
      (error) => {
        if (error.response) {
          console.log("调用接口失败" + error.response.status);
        }
        return Promise.reject(error);
      }
    );
  }

  //项目内部接口请求
  static _request(options, retOrigin, loading) {
    const instance = axios.create();
    options = Object.assign(this._getInsideConfig(options.method), options);
    this._interceptors(instance, options.url, retOrigin, loading);
    return instance(options);
  }

  //请求项目外部接口，如腾讯地图
  static requestExtranal(options) {
    const instance = axios.create();
    return instance(options);
  }

  static uploadFileRequest(options) {
    const instance = axios.create();
    options = Object.assign(this._getInsideConfig(), options);
    return instance(options);
  }

 

  /**
   * 异常
   */
  static requestException(res) {
    return res;
  }

  /* 请求接口 */
  static get(url, data = {}, retOrigin = false, loading = false) {
    return this._request(
      {
        url: this.apiUrl + url,
        method: "get",
        params: data,
      },
      retOrigin,
      loading
    );
  }
  static post(url, data = {}, retOrigin = false, loading = false) {
    return this._request(
      {
        url: this.apiUrl + url,
        method: "post",
        params: {},
        data: qs.stringify(data),
      },
      retOrigin,
      loading
    );
  }

  /**
   * 兼容 PHP 封装（phpAxios）的调用习惯
   * userApi / accountApi / commonApi / productApi 从 phpAxios 迁移过来时保留了大量该调用。
   * javaAxios 的 getRequireParams() 已自动带上 user_id + token，这里无需再设置，保留空实现即可。
   */
  static setLoginParams() {}

  /**
   * 上传文件（对应 phpAxios.postFile）
   * @param {*} url
   * @param {*} data 附加参数
   * @param {*} formData FormData 实例
   */
  static postFile(url, data = {}, formData, retOrigin = false) {
    const dataParams = Object.assign({}, data, this.getRequireParams());
    if (formData instanceof FormData) {
      Object.keys(dataParams).forEach((key) => {
        formData.append(key, dataParams[key]);
      });
    }
    return this.uploadFileRequest({
      url: this.apiUrl + url,
      method: "post",
      processData: false,
      data: formData,
      params: {},
      headers: {
        "Content-Type":
          "multipart/form-data;boundary = " + new Date().getTime(),
      },
    }, retOrigin);
  }
}
